import { toast } from 'react-toastify'

// Without this, a rejected promise that nobody awaits/catches (a fire-and-forget
// fetch, a socket.io callback, etc) fails silently: the browser only logs it to
// devtools, the UI just stops responding, and the user has no idea why.
window.addEventListener('unhandledrejection', (event) => {
	const reason = event.reason
	const message = reason instanceof Error ? reason.message : String(reason)

	console.error('Unhandled promise rejection:', reason)
	toast(`Something went wrong: ${message}`, { type: 'error' })
})
